import React, { Fragment } from 'react';
import { Intro, Slideshow, slideTextTypes, slideTypes } from 'dea-core';
import img1 from '../../assets/images/U1-T1-07A_R.svg';
import img2 from '../../assets/images/U1-T1-07B_L.svg';
import img3 from '../../assets/images/U1-T1-07C_R.svg';
import img4 from '../../assets/images/U1-T1-07D_R.svg';
import img5 from '../../assets/images/U1-T1-07E_L.svg';
import img6 from '../../assets/images/U1-T1-07F_R.svg';
import audio1 from '../../assets/vo/Opioid-M-One-09-NEW.mp3';
import audio2 from '../../assets/vo/Opioid-M-One-09A-NEW.mp3';
import audio3 from '../../assets/vo/Opioid-M-One-09B-NEW.mp3';
import audio4 from '../../assets/vo/Opioid-M-One-09C-NEW.mp3';
import audio5 from '../../assets/vo/Opioid-M-One-09D.mp3';
import audio6 from '../../assets/vo/Opioid-M-One-09E.mp3';

const slides = [
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    // duration: 0.1,
    duration: 9,
    image: img1,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Opioid Prescriptions Tripled'
    },
    vo: {
      sources: [
        {
          src: audio1
        }
      ],
      transcript:
        'The treatment of pain changed slowly. From 1991 – 2001, opioid prescriptions in the United States nearly tripled.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    // duration: 0.1,
    duration: 5,
    image: img2,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text:
        'Opioids were prescribed for pain that they were never intended to treat.'
    },
    vo: {
      sources: [
        {
          src: audio2
        }
      ],
      transcript:
        'Too many prescriptions were written for too many patients for non-malignant pain.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    // duration: 0.1,
    duration: 12,
    image: img3,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'People began sharing or selling their prescriptions.'
    },
    vo: {
      sources: [
        {
          src: audio3
        }
      ],
      transcript:
        'Then, these pills got a life of their own. From the medicine cabinet to other family members, friends, and' +
        ' co-workers. The pills got into the hands of people who didn’t need them.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    // duration: 0.1,
    duration: 16,
    image: img4,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'More Opioid Prescriptions = More Opioid Overdose Deaths'
    },
    vo: {
      sources: [
        {
          src: audio4
        }
      ],
      transcript:
        'And we were not without warning. In 2016, the Centers for Disease Control (or CDC) released findings showing a parallel increase between the number of opioid overdose deaths and the increase in prescriptions.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'left',
    // duration: 0.1,
    duration: 12,
    image: img5,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'New Guidelines to Combat Overprescribing'
    },
    vo: {
      sources: [
        {
          src: audio5
        }
      ],
      transcript:
        'Thankfully, in light of overprescribing, the CDC and various health and medical associations have changed guidelines and prescribing methods regarding quantity, frequency, and dosage.'
    }
  },
  {
    SlideType: slideTypes.HorizontalPan,
    panDirection: 'right',
    // duration: 0.1,
    duration: 6,
    image: img6,
    imageText: '',
    text: {
      type: slideTextTypes.BottomText,
      text: 'Lower Quotas for Opioid Prescription Manufacturing'
    },
    vo: {
      sources: [
        {
          src: audio6
        }
      ],
      transcript:
        'This includes a reduction in the amount of prescription opioids allowed to be manufactured each year.'
    }
  }
];

export default {
  title: 'Prescription Opioid Misuse',
  path: '/elaborate/prescription-opioids',
  content: (
    <Fragment>
      <Intro
        title="Prescription Opioids"
        direction="Select the play button below to begin."
      />
      <Slideshow slides={slides} />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/elaborate/PrescriptionOpioids.js